module.exports = require('./lib/memoize');
